/**
 * Обработчик для преобразования локальных урлов (приходят без порта, что некорректно) при локальной работе
 * @param url
 */
export const processLocalUrl = (url: string | null | undefined) => {
    if (process.env.REACT_APP_ENV === "local") {
        const socketHost = process.env.REACT_APP_SOCKET_HOST ?? "localhost";
        const socketPort = process.env.REACT_APP_CHAT_APP_PORT;
        if (!socketPort || socketPort === "") return url ?? undefined;
        else {
            if (url && url.startsWith(`http://${socketHost}`)) {
                return url.replace(`http://${socketHost}`, `http://${socketHost}:${socketPort}`);
            }
        }
    }

    return url ?? undefined;
};

export const downloadExcelFile = (
    response: { meta: { text: { data: string[] } } } | { data: any; result: string; meta?: any },
    isAtonExcel = false
) => {
    const fileName = isAtonExcel
        ? response.meta.path
        : response.meta.text.data[0] + "/" + response.meta.text.data[1];
    // @ts-ignore // @fixme косяк сборщика
    const filePath = process.env.REACT_APP_API_URL + fileName;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = filePath.split("/").pop() as string;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
